import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import MatchingDetailsLabelValue from "./matchingDetailsLabelValue";

const useStyles = makeStyles(() => ({
  labelValueContainer: {
    marginBottom: 16,
  },
  valueClass: {
    fontSize: 14,
  },
}));

const MatchingDetailsAssessmentCard = ({ assessmentScores = {}, mode }) => {
  const classes = useStyles({ mode });
  const LABEL_VALUES_MAP = [
    {
      label: "Assessment Name",
      value: assessmentScores?.name || "-",
      valueClass: classes.valueClass,
    },
    {
      label: "Sales",
      value:
        assessmentScores?.assessmentList?.find(({ type }) => type === "sales")
          ?.score || "-",
      styleVariant: "scoreCard",
    },
    {
      label: "Service",
      value:
        assessmentScores?.assessmentList?.find(({ type }) => type === "service")
          ?.score || "-",
      styleVariant: "scoreCard",
    },
  ];

  return (
    <Grid container>
      {LABEL_VALUES_MAP.map(
        ({ label, value, styleVariant, valueClass }, index) => (
          <Grid
            item
            xs={12}
            classes={{ root: classes.labelValueContainer }}
            key={label + index}
          >
            <MatchingDetailsLabelValue
              mode={mode}
              label={label}
              value={value}
              valueClass={valueClass}
              styleVariant={styleVariant}
            />
          </Grid>
        )
      )}
    </Grid>
  );
};

export default MatchingDetailsAssessmentCard;
